import { render, staticRenderFns } from "./HotelPreferredVendors.vue?vue&type=template&id=65afa1d7&scoped=true&"
import script from "./HotelPreferredVendors.vue?vue&type=script&lang=js&"
export * from "./HotelPreferredVendors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65afa1d7",
  null
  
)

export default component.exports